import { type ComponentProps } from 'react';

import { Box } from '@eneco/sparky';

import { sizedBoxRecipe, type SizedBoxVariants } from './CircledNumber.css';

type SizedBoxProps = Omit<ComponentProps<typeof Box>, 'backgroundColor'> & SizedBoxVariants;

export const SizedBox = ({ className, backgroundColor, ...props }: SizedBoxProps) => (
  <Box
    className={[sizedBoxRecipe({ backgroundColor }), className].filter(Boolean).join(' ')}
    {...props}
  />
);
